import { api } from '../api';
import { AxiosResponse } from "axios";
import { StandardResponse } from '../interfaces/Common';
import { ExamCodeResponse, ActivateCode } from '../interfaces/Code';

export async function getActivatedCodes(): Promise<StandardResponse<ExamCodeResponse[]>> {
    const response: AxiosResponse<StandardResponse<ExamCodeResponse[]>> = await api.get("/preboard/me/codes");
    return response.data;
}

export async function activateExamCode(request: { code: string; }): Promise<StandardResponse<ActivateCode>> {
    const response: AxiosResponse<StandardResponse<ActivateCode>> = await api.post("/preboard/codes/activate", request);
    return response.data;
}